import { getDimensions } from '@lib/utils/common'
import TestimonialCardSimple from '@components/common/testimonial-card-simple'

const SecondFold = () => {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 px-4">
      <TestimonialCardSimple
        image={{
          src: '/images/referral-page/saransh.png',
          ...getDimensions(294, 333, 0.35),
        }}
        title="Saaransh"
        subtitle="Grade 4"
        message={`I'm glad to have learnt coding with Codingal. I now have two apps published on the Google Play Store.`}
      />
      <TestimonialCardSimple
        image={{
          src: '/images/home/testimonials/new/roopa.png',
          ...getDimensions(294, 333, 0.35),
        }}
        title="Roopa"
        subtitle="Parent"
        message={`Codingal builds a strong foundation and has helped enhance my daughter's confidence and creativity.`}
      />
    </section>
  )
}

export default SecondFold
